//contextos
import { useMesa } from "../../../../contexto/provider/MesaContext.js";

import ProductoLabel from "../etiqueta/ProductoLabel.js";

//botoneras
import BotonEliminar from "../../../../componentsUI/formularios/button/BotonEliminar.js";
import BotoneraMasMenos from "../botonera/ProductoBotoneraCanasta.js";
import BotonAgregar from "../../../../componentsUI/formularios/button/ButtonAgregar.js";

import "./ProductoLista.css";

// carga de productos en la lista de carrito
export default function ProductoLista({
  productos = [],
  onEliminar,
  onActualizarCantidad,
  onOrdenCreada,
}) {
  const { mesaSeleccionada, guardarOrdenMesaContext } = useMesa();

  if (productos.length === 0) {
    return <p className="mensaje-vacio">No hay productos seleccionados</p>;
  }

  // ---------------------------------------
  // Crear Orden Contexto
  // ---------------------------------------

  const handleCrearOrdenContexto = () => {
    if (!mesaSeleccionada) {
      alert("Debes seleccionar una mesa antes de crear la orden.");
      return;
    }

    const productosEnCanasta = productos.map((p) => {
      console.log("Procesando producto:", p);
      return {
        id: p.id,
        nombre: p.nombre,
        precio: p.precio,
        cantidad: p.cantidad,
        subtotal: p.precio * p.cantidad,
      };
    });

    guardarOrdenMesaContext(mesaSeleccionada, productosEnCanasta);

    console.log("Orden creada globalmente:", {
      mesa: mesaSeleccionada,
      productos: productosEnCanasta,
    });

    onOrdenCreada?.({
      mesa: mesaSeleccionada,
      productos: productosEnCanasta,
    });
  };

  const total = productos.reduce((acc, p) => acc + p.precio * p.cantidad, 0);

  return (
    <div className="producto-lista">
      {/* Contexto */}
      <h3 className="producto-lista-titulo">
        Canasta – Mesa {mesaSeleccionada}
      </h3>

      {/* Contenido */}
      <ul className="producto-lista-ul">
        {productos.map((p) => (
          <li key={p.id} className="producto-lista-item">
            <fieldset className="producto-fieldset">
              <legend className="producto-legend">{p.nombre}</legend>

              <div className="producto-fila">
                <BotoneraMasMenos
                  id={p.id}
                  cantidad={p.cantidad}
                  onCantidadChange={onActualizarCantidad}
                />

                <ProductoLabel
                  valor={p.precio * p.cantidad}
                  editable={false}
                  formato={(v) =>
                    new Intl.NumberFormat("es-CO", {
                      style: "currency",
                      currency: "COP",
                      minimumFractionDigits: 0,
                    }).format(v)
                  }
                />

              </div>
                              <BotonEliminar id={p.id} onEliminar={onEliminar} />

            </fieldset>
          </li>
        ))}
      </ul>

      {/* Acción final */}
      <div className="producto-lista-footer">
        <div className="producto-total">
          <span>Total</span>
          <strong>
            {new Intl.NumberFormat("es-CO", {
              style: "currency",
              currency: "COP",
              minimumFractionDigits: 0,
            }).format(total)}
          </strong>
        </div>

        <BotonAgregar
          texto="Crear Orden"
          className="boton-agregar"
          onClick={handleCrearOrdenContexto}
        />
      </div>
    </div>
  );
}
